// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Tzyz","title":"InfoRow_title__1Lb1y"};